import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const {
    ref,
    isVisible
  } = useScrollReveal(0);
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-6 pt-20 overflow-hidden" data-id="element-139">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-140">
        <img src="https://cdn.magicpatterns.com/uploads/mTzriaDYAht46x61HPAM1E/aboutme_texture.jpg" alt="" className="w-full h-full object-cover" data-id="element-141" />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-black/70" data-id="element-142" />
      </div>

      {/* Architectural Guides */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-143">
        {/* Center Vertical Line */}
        <div className="absolute left-1/2 top-0 bottom-0 w-px bg-white/5 -translate-x-1/2" data-id="element-144" />
        {/* Center Horizontal Line */}
        <div className="absolute top-1/2 left-0 right-0 h-px bg-white/5 -translate-y-1/2" data-id="element-145" />
        {/* Grid pattern overlay */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:100px_100px]" data-id="element-146" />
      </div>

      {/* Coordinate Metadata - Top Right */}
      <div className="absolute top-24 right-6 md:top-32 md:right-12 font-mono text-[10px] md:text-xs text-white/60 border border-white/20 p-3 md:p-4 backdrop-blur-sm" data-id="element-147">
        <div className="flex flex-col gap-1" data-id="element-148">
          <span className="tracking-widest" data-id="element-149">LOC: 40.7128° N</span>
          <span className="tracking-widest" data-id="element-150">LON: 74.0060° W</span>
          <div className="h-px w-full bg-white/20 my-1" data-id="element-151" />
          <span className="tracking-widest" data-id="element-152">SEC: 01 // HERO</span>
        </div>
      </div>

      <div ref={ref} className={`relative z-10 text-center transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} data-id="element-153">
        {/* Architectural Title Treatment */}
        <div className="relative mb-12" data-id="element-154">
          <h1 className="text-[8vw] md:text-[6vw] leading-none font-extralight tracking-[0.3em] md:tracking-[0.5em] uppercase text-white mix-blend-difference" data-id="element-155">
            <span className="block" data-id="element-156">Taylor</span>
            <span className="block mt-4 md:mt-0" data-id="element-157">Sams</span>
          </h1>
          {/* Decorative bracket lines */}
          <div className="absolute -left-8 top-0 bottom-0 w-px bg-white/20 hidden md:block" data-id="element-158" />
          <div className="absolute -right-8 top-0 bottom-0 w-px bg-white/20 hidden md:block" data-id="element-159" />
        </div>

        <p className="text-sm md:text-base font-mono text-gray-200 max-w-xl mx-auto tracking-widest leading-relaxed mb-16 border-l border-white/20 pl-6 text-left" data-id="element-160">
          Hi nice to meet you, I'm currently a digital product designer at BNY,
          
          I use my background in architecture to bridge the gap between human needs and technical systems. 
          <br data-id="element-161" />
          Designer of products, spaces, and all scales of experiences in between.
        </p>

        <div className="flex flex-col items-center gap-4 animate-bounce opacity-50" data-id="element-162">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-gray-200" data-id="element-163">
            Scroll to explore
          </span>
          <ArrowDown className="text-white w-4 h-4 stroke-[1]" data-id="element-164" />
        </div>
      </div>
    </section>;
}